export enum AlgoliaFacets {
	'College credits' = 'minCollegeCredits',
	'College GPA' = 'minCollegeGpa',
	'Education goal' = 'educationGoal',
	'Education level' = 'minEduLevel',
	'Generic roles' = 'genericRoles.lvl0',
	'Generic roles children' = 'genericRoles.lvl1',
	'High school GPA' = 'minHsGpa',
	'Interests' = 'hierarchicalInterests.lvl0',
	'Interests children' = 'hierarchicalInterests.lvl1',
	'Learning provider' = 'studentFacingAcademicPartner.name',
	'Program format' = 'programFormat',
	'Program type' = 'programType.lvl0',
	'Program type children' = 'programType.lvl1',
	'Specific roles' = 'specificRoles.lvl0',
	'Specific roles children' = 'specificRoles.lvl1',
	'Destination roles' = 'destinationRoles.lvl0',
	'Destination roles children' = 'destinationRoles.lvl1',
	'Time to complete' = 'minCompletionDays',
	'Tuition funding' = 'fundingLevel',
	'Open programs' = 'isAcceptingApplications',
}

export type AlgoliaFacetsType = {
	completionTimeRange: Record<string, number>;
	fundingLevel: Record<string, number>;
	'genericRoles.lvl0'?: Record<string, number>;
	'genericRoles.lvl1'?: Record<string, number>;
	'hierarchicalInterests.lvl0': Record<string, number>;
	'hierarchicalInterests.lvl1': Record<string, number>;
	'programType.lvl0': Record<string, number>;
	'programType.lvl1': Record<string, number>;
	'specificRoles.lvl0'?: Record<string, number>;
	'specificRoles.lvl1'?: Record<string, number>;
	'destinationRoles.lvl0'?: Record<string, number>;
	'destinationRoles.lvl1'?: Record<string, number>;
	'studentFacingAcademicPartner.name': Record<string, number>;
	weeklyEffortRange: Record<string, number>;
	isAcceptingApplications: Record<string, number>;
	programFormatDisplay: Record<string, number>;
};

export enum Filters {
	maxCompletionDays = 'maxCompletionDays',
	minEduLevel = 'minEduLevel',
	minHsGpa = 'minHsGpa',
	minCollegeGpa = 'minCollegeGpa',
	minCollegeCredits = 'minCollegeCredits',
	minCompletionDays = 'minCompletionDays',
	minEffortHours = 'minEffortHours',
	maxEffortHours = 'maxEffortHours',
}

export const timeToCompleteRanges = [
	'Any time to complete',
	'Up to 2 months',
	'Up to 6 months',
	'Up to 2 years',
	'Up to 4 years',
];

export const weeklyEffortRanges = [
	'Any hours per week',
	'Up to 2 hours per week',
	'Up to 6 hours per week',
	'Up to 12 hours per week',
	'Up to 24 hours per week',
];

export type AlgoliaUiStateType = {
	[x: string]: {
		menu: {
			completionTimeRange: Record<string, number>;
			fundingLevel: Record<string, number>;
			isAcceptingApplications: Record<string, number>;
		};
		refinementList: {
			fundingLevel: string[];
			'genericRoles.lvl0': string[];
			'genericRoles.lvl1': string[];
			'hierarchicalInterests.lvl0': string[];
			'hierarchicalInterests.lvl1': string[];
			programFormatDisplay: string[];
			'programType.lvl0': string[];
			'programType.lvl1': string[];
			'specificRoles.lvl0': string[];
			'specificRoles.lvl1': string[];
			'destinationRoles.lvl0': string[];
			'destinationRoles.lvl1': string[];
			'studentFacingAcademicPartner.name': string[];
		};
		page: number;
		query: string;
	};
};
